export function defineChain(chain){return{formatters:void 0,fees:void 0,serializers:void 0,...chain}}